import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import App from './App.vue'
import router from './router'
import store from './store'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAward,
  faHome,
  faInfoCircle,
  faUsers,
  faFire,
  faClipboardList,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faAward, faHome, faInfoCircle, faUsers, faFire, faClipboardList)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const debug = false // || process.env.NODE_ENV == 'development'
const serverAddress = debug ? 'localhost:14789' : 'https://proxy.zawody-lucznicze.pl'

Vue.config.productionTip = false

Vue.use(
  new VueSocketIO({
    debug,
    connection: serverAddress,
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET)',
    },
  })
)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
